import React, { useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const initial = { name: "", phone: "", email: "", party: "", date: "", time: "", occasion: "", notes: "" };

export default function Reserve() {
  const [form, setForm] = useState(initial);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState(false);
  const [busy, setBusy] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setMsg("");
    setErr(false);
    try {
      await axios.post(`${API}/reservations`, form);
      const name = form.name.trim() || "there";
      setMsg(
        `Thanks, ${name} — we'll confirm your table for ${form.date || "your chosen date"} at ${
          form.time || "your chosen time"
        } by email shortly.`
      );
      setForm(initial);
    } catch (e2) {
      setErr(true);
      setMsg("Something went wrong sending your request. Please try again or call us.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section id="reserve">
      <div className="wrap">
        <div className="reserve-grid">
          <div>
            <span className="eyebrow" data-reveal="fade">Book a table</span>
            <h2 className="reserve-title" data-reveal="fade" data-reveal-delay="1">
              Come argue with us about which counter is better.
            </h2>
            <p className="reserve-lead" data-reveal data-reveal-delay="2">
              Tables are held for 15 minutes past booking time. For parties of 8 or more, call us
              directly so we can push a few tables together.
            </p>
            <div className="reserve-note" data-reveal data-reveal-delay="3">
              <strong>Good to know</strong>
              <p>
                We hold a handful of walk-in seats at the coffee counter every night — first come,
                first poured.
              </p>
              <p>Let us know about allergies in the notes field; both kitchens cook to order.</p>
            </div>
          </div>

          <form id="reserve-form" onSubmit={submit} data-reveal data-reveal-delay="2">
            <div className="field">
              <label htmlFor="r-name">Name</label>
              <input id="r-name" type="text" required placeholder="Your name" value={form.name} onChange={update("name")} />
            </div>
            <div className="field">
              <label htmlFor="r-phone">Phone</label>
              <input id="r-phone" type="tel" required placeholder="07…" value={form.phone} onChange={update("phone")} />
            </div>
            <div className="field">
              <label htmlFor="r-email">Email</label>
              <input id="r-email" type="email" required placeholder="you@example.com" value={form.email} onChange={update("email")} />
            </div>
            <div className="field">
              <label htmlFor="r-party">Party size</label>
              <select id="r-party" required value={form.party} onChange={update("party")}>
                <option value="">Select</option>
                <option>1</option><option>2</option><option>3</option><option>4</option>
                <option>5</option><option>6</option><option>7</option>
                <option>8+ — please call</option>
              </select>
            </div>
            <div className="field">
              <label htmlFor="r-date">Date</label>
              <input id="r-date" type="date" required value={form.date} onChange={update("date")} />
            </div>
            <div className="field">
              <label htmlFor="r-time">Time</label>
              <input id="r-time" type="time" required value={form.time} onChange={update("time")} />
            </div>
            <div className="field full">
              <label htmlFor="r-occasion">Occasion (optional)</label>
              <select id="r-occasion" value={form.occasion} onChange={update("occasion")}>
                <option value="">Just because</option>
                <option>Birthday</option>
                <option>Anniversary</option>
                <option>Business</option>
                <option>First visit</option>
              </select>
            </div>
            <div className="field full">
              <label htmlFor="r-notes">Notes — allergies, high chairs, seating</label>
              <textarea id="r-notes" placeholder="Anything we should know before you arrive" value={form.notes} onChange={update("notes")} />
            </div>
            <div className="reserve-submit">
              <button type="submit" className="btn btn-solid" disabled={busy}>
                {busy ? "Sending…" : "Request a table"}
              </button>
              <span className={`form-msg${msg ? " show" : ""}${err ? " err" : ""}`}>{msg}</span>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
